export const ConfidenceLevel = ({ level }) => {
    const color = "var(--cm-p-accent-500)";

    return (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="5" width="2.5" height="5" fill={color} />
            <rect x="3.75" y="2.5" width="2.5" height="7.5" fill={color} fillOpacity={level > 1 ? 1 : 0.2} />
            <rect x="7.5" width="2.5" height="10" fill={color} fillOpacity={level === 3 ? 1 : 0.2} />
        </svg>
    );
};
